import { Drawer, useGlobalCopyStore } from '../../common'
import PaydownContent from './debtspaydown/PaydownContent'

interface PaydownDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const PaydownDrawer = ({ isOpen, onClose }: PaydownDrawerProps) => {
  const { debts: copy } = useGlobalCopyStore()

  return (
    <Drawer
      ariaLabelClose={copy.paydown_drawer_close_aria}
      isOpen={isOpen}
      onClose={onClose}
      title={copy.paydown_drawer_title}
    >
      <PaydownContent />
    </Drawer>
  )
}

export default PaydownDrawer
